(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gripped-eu-product-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gripped-product-menu')) {
    customElements.define('gripped-product-menu', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const details = this.querySelector('details');
        const trigger = details?.querySelector('summary');
        if (!details || !trigger) return;
        const close = (restoreFocus = false) => {
          details.open = false;
          if (restoreFocus) trigger.focus();
        };
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            event.stopPropagation();
            close(true);
          }
        }, { signal });
        document.addEventListener('pointerdown', (event) => {
          if (details.open && !this.contains(event.target)) close();
        }, { signal });
        this.addEventListener('focusout', (event) => {
          if (details.open && event.relatedTarget && !details.contains(event.relatedTarget)) close();
        }, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
